import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import Header from "./components/Header/Header";
import Sidebar from "./components/Sidebar/Sidebar";
import Chat from "./components/Chat/Chat";
import { useStateValue } from "./components/StateProvider";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import Login from "./components/Auth/Login";
import ChatHome from "./components/ChatHome/ChatHome";
import { auth } from "./components/firebase";
import { actionTypes } from "./components/reducer";
import { useOnClickOutside } from "./components/useOutsideClick";
import Dashboard from "./components/Dashboard/Dashboard";
import Notes from "./components/Notes/Notes";
import UserPage from "./components/UserPage/UserPage";

function App() {
  const [{ user }, dispatch] = useStateValue();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const handleSearchVisibility = () => setIsVisible(!isVisible);
  const ref = useRef();

  useOnClickOutside(ref, () => setSidebarOpen(false));

  useEffect(() => {
    const unlisten = auth.onAuthStateChanged((user) => {
      user
        ? dispatch({
            type: actionTypes.SET_USER,
            user: user,
          })
        : dispatch({
            type: actionTypes.SET_USER,
            user: null,
          });
    });
    return () => {
      unlisten();
    };
  }, []);

  const toggle = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="app">
      <Router>
        {!user ? (
          <Login />
        ) : (
          <>
            <Header
              toggle={toggle}
              handleSearchVisibility={handleSearchVisibility}
              isVisible={isVisible}
              setIsVisible={setIsVisible}
            />

            <div ref={ref}>
              <Sidebar
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
              />
            </div>

            <Switch>
              <Route path="/room/:roomId">
                <Chat />
              </Route>
              <Route exact path="/">
                <ChatHome />
              </Route>
              <Route path="/home">
                <Dashboard />
              </Route>
              <Route path="/notes">
                <Notes />
              </Route>
              <Route path="/drafts">
                <Notes />
              </Route>
              <Route path="/apps">
                <Notes />
              </Route>
              <Route path="/inbox">
                <Notes />
              </Route>
              <Route path="/components">
                <Notes />
              </Route>
              <Route path="/feedback">
                <Notes />
              </Route>
              <Route path="/associates">
                <Notes />
              </Route>
              <Route path="/userinfo">
                <UserPage />
              </Route>
            </Switch>
          </>
        )}
      </Router>
    </div>
  );
}

export default App;
